var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price-card-big",class:{'price-card-big__error-type': _vm.typeError}},[(_vm.typeError)?_c('div',{staticClass:"price-card-big__error-img"}):_vm._e(),_c('div',{staticClass:"price-card-big__title"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{staticClass:"price-card-big__txt"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }